import { tsrContractsClient } from '../tsrContractsClient';

const downloadDocumentClient = tsrContractsClient.documentContract;

export default downloadDocumentClient;
